/* eslint-disable prettier/prettier */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Modal,
  Typography,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles from '../../../../assets/styles/pages/ShopRequest';
import Header from '../../../../components/Header';

// import svg
import { ReactComponent as IconPlus } from '../../../../assets/images/svg/shops/request/button_mais.svg';
import { ReactComponent as IconLess } from '../../../../assets/images/svg/shops/request/button_menos.svg';
import { ReactComponent as IconObservation } from '../../../../assets/images/svg/shops/request/icon_observacao.svg';
import { ReactComponent as IconArrowRight } from '../../../../assets/images/svg/shops/request/icon_seta_direita.svg';
import { ReactComponent as IconRequest } from '../../../../assets/images/svg/shops/request/icon_pedido.svg';

import { FormatPrice } from '../../../../helpers/utils/Formating';
import { handleSaveCartStorage } from '../../../../helpers/cart/product';
import {
  getStorege,
  removeStorege,
  saveStorege,
} from '../../../../helpers/db_storage';
import { handleSaveAdditionalCartStorage } from '../../../../helpers/cart/additional';
import { handleSaveFlavorCartStorage } from '../../../../helpers/cart/flavor';
import { CalcCartProduct } from '../../../../helpers/utils/CalcProduct';
import { handleSaveOptionLevelCartStorage } from '../../../../helpers/cart/optionLevel';
import { useShopContext } from '../../../../providers/use-shop';
import { useTrackingContext } from '../../../../context/TrackingContext';

const styleModal = {
  position: 'absolute' as const,
  top: '100%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  bgcolor: 'background.paper',
  border: '2px solid #ffffff',
  boxShadow: 24,
  p: 4,
  outline: 'none',
};

const RequestNote: React.FC = () => {
  const navigate = useNavigate();
  const classeStyle = useStyles();
  const { idRestaurante, id_product, id_promotion, des_promotion }: any =
    useParams();
  const idShop = window.atob(idRestaurante);
  const idProduct = window.atob(id_product);
  const { data }: any = useShopContext();
  const { trackEvent } = useTrackingContext();

  const [incrementQt, setIncrementQt] = useState<number>(1);
  const [observation, setObservation] = useState<string>('');
  const [product, setProduct] = useState<any>([]);
  const [promotion, setPromotion] = useState<any>();
  const [request, setRequest] = useState<any>();
  const [vlProduct, setVlProduct] = useState<any>([]);
  const [additional, setAdditional] = useState<any>([]);
  const [flavor, setFlavor] = useState<any>([]);
  const [optionLevel, setOptionLevel] = useState<any>([]);
  const [openModalConfirmRequest, setOpenModalConfirmRequest] = useState(false);

  const handleToPage = (url: string) => {
    return navigate(url, { replace: true });
  };

  const handleSaveProduct = (param: string) => {
    let result = handleSaveCartStorage(
      product,
      {
        observation,
        incrementQt,
        idShop,
        idRestaurante,
        vlProduct,
        idSituacao: 0,
        promotion: param === 'promotion',
        promotionMaxStage: promotion?.promotionMaxStage || '',
        dsImagemEstabelecimento: data.shop.dsImagem,
        dsNomeEstabelecimento: data.shop.dsNome,
        promotionDeliveryFree: request?.promotionDeliveryFree,
      },
      'product',
      param === 'promotion'
        ? '@mais/delivery/shop/request/product/cart/promotion'
        : '@mais/delivery/shop/request/product/cart',
    );

    if (additional?.length > 0) {
      result = handleSaveAdditionalCartStorage(
        additional,
        {
          idShop,
          idPedidoCardapio: product.idPedidoCardapio,
          idCardapio: idProduct,
          qtSabores: '',
        },
        'additional',
        param === 'promotion'
          ? '@mais/delivery/shop/request/product/cart/promotion'
          : '@mais/delivery/shop/request/product/cart',
      );
    }

    if (flavor?.length > 0) {
      result = handleSaveFlavorCartStorage(
        flavor,
        {
          idShop,
          idPedidoCardapio: product.idPedidoCardapio,
          idCardapio: idProduct,
          qtSabores: 0,
        },
        'flavor',
        param === 'promotion'
          ? '@mais/delivery/shop/request/product/cart/promotion'
          : '@mais/delivery/shop/request/product/cart',
      );
    }

    if (optionLevel?.length > 0) {
      result = handleSaveOptionLevelCartStorage(
        optionLevel,
        {
          idShop,
          idPedidoCardapio: product.idPedidoCardapio,
          idCardapio: idProduct,
          qtSabores: '',
        },
        'optionLevel',
        param === 'promotion'
          ? '@mais/delivery/shop/request/product/cart/promotion'
          : '@mais/delivery/shop/request/product/cart',
      );
    }

    if (result?.remove) {
      toast.info('Seu carrinho expirou, por favor faça seu pedido novamente.');
      removeStorege('@mais/delivery/shop/request/data/cart');
    }

    removeStorege('@mais/delivery/shop/request/product/treat');

    if (param === 'buy') {
      if (id_promotion) {
        saveStorege('@mais/delivery/shop/request/cart/filter/payment', {
          dsFiltroPagamento: promotion?.dsFiltroPagamento,
        });
      }
      removeStorege('@mais/delivery/shop/request/product/promotion');
      handleToPage(`/shop/detail/list/product/subcategorie/${idRestaurante}`);
    } else if (param === 'promotion') {
      if (id_promotion) {
        saveStorege('@mais/delivery/shop/request/cart/filter/payment', {
          dsFiltroPagamento: promotion?.dsFiltroPagamento,
        });
      }
      handleToPage(
        `/shop/detail/list/product/subcategorie/${idRestaurante}/${id_promotion}/${window.btoa(
          'promotion_next',
        )}`,
      );
    } else {
      if (id_promotion) {
        saveStorege('@mais/delivery/shop/request/cart/filter/payment', {
          dsFiltroPagamento: promotion?.dsFiltroPagamento,
        });
      }
      removeStorege('@mais/delivery/shop/request/product/promotion');
      handleToPage(`/shop/request/detail/${idRestaurante}`);
    }
  };

  const handleOpenModalConfirmRequest = () => {

    // enviar evento somente quando criar o carrinho.
    if (!getStorege('@mais/delivery/shop/request/product/cart')) {
      trackEvent('AddToCart');
    }

    if (
      id_promotion &&
      (window.atob(des_promotion) === 'promotion' ||
        window.atob(des_promotion) === 'promotion_next')
    ) {
      const result = getStorege(
        '@mais/delivery/shop/request/product/promotion',
      );
      if (result == null) {
        setOpenModalConfirmRequest(true);
        return;
      }
      if (
        parseInt(result.promotionCurrentStage + 1, 10) ===
        parseInt(result.promotionMaxStage, 10)
      ) {
        const resultCart = getStorege(
          '@mais/delivery/shop/request/product/cart',
        );
        const resultCompleted = getStorege(
          '@mais/delivery/shop/request/product/cart/promotion',
        );

        if (resultCart && resultCompleted) {
          if (resultCompleted?.adicional) {
            if (resultCart?.adicional) {
              const arr_adittional = [
                ...resultCart.adicional,
                ...resultCompleted.adicional,
              ];
              resultCart.adicional = arr_adittional;
            } else {
              resultCart.adicional = resultCompleted.adicional;
            }
          }
          if (resultCompleted?.sabor) {
            if (resultCart?.sabor) {
              const arr_flavor = [
                ...resultCart.sabor,
                ...resultCompleted.sabor,
              ];

              resultCart.sabor = arr_flavor;
            } else {
              resultCart.sabor = resultCompleted.sabor;
            }
          }
          if (resultCompleted?.pedido_cardapio) {
            resultCart.pedido_cardapio.push(...resultCompleted.pedido_cardapio);
          }
          if (resultCompleted?.opcoes) {
            if (resultCart?.opcoes) {
              const arr_nivel = [
                ...resultCart.opcoes,
                ...resultCompleted.opcoes,
              ];

              resultCart.opcoes = arr_nivel;
            } else {
              resultCart.opcoes = resultCompleted.opcoes;
            }
          }
          resultCart.idPedidoCardapioTotal +=
            resultCompleted.idPedidoCardapioTotal;

          resultCart.promotionDeliveryFree =
            resultCompleted.promotionDeliveryFree;
        }
        if (resultCompleted) {
          saveStorege(
            '@mais/delivery/shop/request/product/cart',
            resultCart || resultCompleted,
          );

          saveStorege('@mais/delivery/shop/request/cart/filter/payment', {
            dsFiltroPagamento: result?.dsFiltroPagamento,
          });
          removeStorege('@mais/delivery/shop/request/product/cart/promotion');
          removeStorege('@mais/delivery/shop/request/product/promotion');
        }
        setOpenModalConfirmRequest(true);
        return;
      }
      handleSaveProduct('promotion');
    }
    setOpenModalConfirmRequest(true);
  };

  const handleCloseModalConfirmRequest = () => {
    setOpenModalConfirmRequest(false);
  };

  const getProductStorage = async (): Promise<any> => {
    const dataStorage = getStorege('@mais/delivery/shop/request/product/treat');
    setRequest(dataStorage);

    const resultProduct = dataStorage?.pedido_cardapio.find(
      (productData: any) =>
        Number(productData.idCardapio) === Number(idProduct),
    );
    if (dataStorage?.sabor?.length > 0) {
      const resultFalvor = dataStorage?.sabor.filter(
        (flavorData: any) =>
          Number(flavorData.idPedidoCardapio) ===
          Number(resultProduct.idPedidoCardapio),
      );
      setFlavor(resultFalvor);
    }

    if (dataStorage?.adicional?.length > 0) {
      const resultAdditional = dataStorage?.adicional.filter(
        (additionalData: any) =>
          Number(additionalData.idPedidoCardapio) ===
          Number(resultProduct.idPedidoCardapio),
      );
      setAdditional(resultAdditional);
    }

    if (dataStorage?.opcoes?.length > 0) {
      const resultOptionLevel = dataStorage?.opcoes.filter(
        (optionLevelData: any) =>
          Number(optionLevelData.idPedidoCardapio) ===
          Number(resultProduct.idPedidoCardapio),
      );
      setOptionLevel(resultOptionLevel);
    }
    setProduct(resultProduct);
  };

  useEffect(() => {
    async function CalcProduct() {
      if (product?.idCardapio) {
        const resultCalc = await CalcCartProduct(
          product,
          flavor,
          additional,
          optionLevel,
        );
        setVlProduct(resultCalc);
      }
    }
    CalcProduct();
  }, [product, flavor, additional, optionLevel]);

  useEffect(() => {
    getProductStorage();
  }, []);

  useEffect(() => {
    const dataStorage = getStorege('@mais/delivery/shop/request/product/treat');

    if (!dataStorage) {
      handleToPage(`/shop/detail/list/product/subcategorie/${idRestaurante}`);
    }
  }, []);

  useEffect(() => {
    const resultPromotion = getStorege(
      '@mais/delivery/shop/request/product/promotion',
    );

    setPromotion(resultPromotion);
  }, []);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      {product && (
        <>
          <Header children="DetailRequest" />
          <CssBaseline />
          <Grid
            container
            item
            justifyContent="center"
            alignItems="center"
            marginBottom="50px"
          >
            <Grid className={classeStyle.gridMain}>
              <h3>Produto</h3>
              <Grid>
                <Grid className={classeStyle.gridProduct}>
                  <Grid className={classeStyle.gridBannerAndDes}>
                    {product.dsImagem && (
                      <img
                        src={`${
                          process.env.REACT_APP_API_IMG + product.dsImagem
                        }`}
                        alt="banner"
                        className={classeStyle.bannerProduct}
                      />
                    )}
                    <Grid width="100%" marginLeft="10px">
                      <h5 className={classeStyle.titleProduct}>
                        {product.dsNome}
                      </h5>
                      <p className={classeStyle.textDesProduct}>
                        {product.dsDescricao}
                      </p>
                      <Grid>
                        {flavor.length > 0 &&
                          flavor.map((flavorItem: any) => (
                            <p
                              className={classeStyle.textDesProduct}
                              key={flavorItem.idSabor}
                            >
                              * {flavorItem.dsSabor}
                            </p>
                          ))}
                        {additional.length > 0 &&
                          additional.map((additionalItem: any) => (
                            <p
                              className={classeStyle.textDesProduct}
                              key={additionalItem.idAdicional}
                            >
                              * {additionalItem.qtItens}x{' '}
                              {additionalItem.dsNome}
                            </p>
                          ))}
                        {optionLevel.length > 0 &&
                          optionLevel.map((optionLevelItem: any) => (
                            <p
                              className={classeStyle.textDesProduct}
                              key={optionLevelItem.idOpcaoNivel}
                            >
                              * {optionLevelItem.qtItens}x{' '}
                              {optionLevelItem.dsNome}
                            </p>
                          ))}
                        <p />
                      </Grid>
                      <Grid
                        className={classeStyle.gridVlQtProduct}
                        style={
                          product.dsDescricao
                            ? { marginTop: 0 }
                            : { marginTop: 20 }
                        }
                      >
                        <p className={classeStyle.textVlProduct}>
                          R$ {FormatPrice(parseFloat(vlProduct) * incrementQt)}
                        </p>
                        {!id_promotion || (id_promotion && promotion?.promotionMaxStage == 1) ? (
                            <Grid
                              className={classeStyle.gridIncrementQtProduct}
                            >
                              <IconLess
                                onClick={() =>
                                  setIncrementQt(
                                    incrementQt > 1 ? incrementQt - 1 : 1,
                                  )
                                }
                              />
                              <p className={classeStyle.textQtProduct}>
                                {incrementQt}
                              </p>
                              <IconPlus
                                onClick={() => setIncrementQt(incrementQt + 1)}
                              />
                            </Grid>
                          ) : ''}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid className={classeStyle.gridObservationMain}>
                <Grid className={classeStyle.gridObservation}>
                  <IconObservation />
                  <h4 className={classeStyle.titleObservation}>
                    Alguma observação?
                  </h4>
                </Grid>
                <hr className={classeStyle.hr} />

                <Grid>
                  <textarea
                    className={classeStyle.textArea}
                    placeholder=""
                    onChange={(e) => setObservation(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Button
                className={classeStyle.btnSubmit}
                type="submit"
                variant="contained"
                onClick={handleOpenModalConfirmRequest}
              >
                <p className={classeStyle.textBtnSubmit}>Continuar</p>
                <IconArrowRight />
              </Button>
              <Modal
                open={openModalConfirmRequest}
                onClose={handleCloseModalConfirmRequest}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={{ ...styleModal, height: '650px' }}>
                  <Grid container item xs={12} justifyContent="center">
                    <IconRequest className={classeStyle.iconModal} />
                  </Grid>
                  <Grid container item xs={12} justifyContent="center">
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h4"
                      className={classeStyle.titleModal}
                      style={{ fontWeight: '550' }}
                    >
                      Pedido
                    </Typography>
                    <Typography
                      id="modal-modal-description"
                      sx={{ mt: 2 }}
                      className={classeStyle.textModal}
                    >
                      Deseja finalizar seu pedido?
                    </Typography>
                  </Grid>

                  <Grid
                    container
                    item
                    justifyContent="flex-start"
                    alignItems="center"
                    textAlign="center"
                  />
                  <Button
                    className={classeStyle.btnSubmit}
                    type="submit"
                    variant="contained"
                    onClick={() => handleSaveProduct('finish')}
                  >
                    Prosseguir para o pagamento
                    <IconArrowRight className={classeStyle.iconArrow} />
                  </Button>

                  <Grid container item xs={12} justifyContent="center">
                    <Button
                      variant="text"
                      onClick={() => handleSaveProduct('buy')}
                    >
                      <p className={classeStyle.textBtnKeepShopping}>
                        Continuar comprando
                      </p>
                    </Button>
                  </Grid>
                  <Grid container item xs={12} justifyContent="center">
                    <Button
                      onClick={handleCloseModalConfirmRequest}
                      variant="text"
                    >
                      <p className={classeStyle.textBtnKeepShopping}>Fechar</p>
                    </Button>
                  </Grid>
                </Box>
              </Modal>
            </Grid>
          </Grid>
        </>
      )}
    </Container>
  );
};

export default RequestNote;
